<template>
  <button class="SlideButton">{{ text }}</button>
</template>

<script>
export default {
  props: {
    text: String,
  }
}
</script>

<style scoped>
.SlideButton {
  background-color: var(--brand-color);
  padding: var(--spacing-4) var(--spacing-9);
  min-width: 14rem;
  border-radius: 5px;
  font-weight: 600;
  font-size: var(--font-size-4);
  line-height: 1;
  color: var(--text-color-white);
  transition: filter 0.15s;
}
.SlideButton:hover {
  filter: brightness(1.15);
}
</style>
